import { useAirModal } from '@air/provider-modal';

import { BoardTemplateModal } from '~/components/Modals/BoardTemplateModal/BoardTemplateModal';

export const useBoardTemplateModal = () => {
  const [showModal] = useAirModal(BoardTemplateModal);

  return { showBoardTemplateModal: showModal };
};
